import {createTheme} from '@mui/material/styles'

// Create a theme instance.
const theme = createTheme({
  cssVariables: true,
  palette: {
    background: {
      default: '#F0EEEB',
      paper: '#F0EEEB'
    },
    primary: {
      main: '#4E9E9A'
    },
    secondary: {
      main: '#8871B9'
    },
    error: {
      main: '#910708'
    },
    text: {
      primary: '#004056',
      secondary: '#F0EEEB',
    },
  },
  typography: {
    fontFamily: 'Funnel Display, Sans-serif'
  }
})

export default theme
